import styled from 'styled-components';

export const Container = styled.div`
  background: #0f0f0f;

  display: flex;
  overflow: hidden;

  flex: 1;
  width: 100%;
  height: 100%;
`;

export const Sidebar = styled.div`
  width: 10rem;
  height: 100%;

  border-right: 1px solid #cfcfcf;

  > ul {
    > li {
      display: flex;
      align-items: center;

      height: 5.2rem;
      padding-left: 1rem;

      cursor: pointer;
      transition: ${({ theme }) => theme.transition.default};

      > p {
        font-size: 1.6rem;
        line-height: 3.5rem;
        color: #ffffff;

        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }

      :hover {
        background: #242424;
      }

      &.active {
        background: #242424;
        border-right: 4px solid #ffd503;

        > p {
          font-weight: bold;
          color: #ffdf22;
        }
      }

      @media (min-width: 768px) {
        padding-left: 3.2rem;

        > p {
          font-size: 1.9rem;
        }
      }
    }
  }

  @media (min-width: 768px) {
    width: 27rem;
  }
`;

export const Content = styled.div`
  width: 100%;
  height: 100%;
  flex: 1;
  overflow: auto;
`;

export const StudentHeader = styled.div`
  background: #000000;

  border-bottom: 1px solid #cfcfcf;

  padding: 0 1rem;

  @media (min-width: 425px) {
    display: flex;
    justify-content: space-between;
  }

  @media (min-width: 768px) {
    height: 21.6rem;

    padding: 2rem;
  }

  @media (min-width: 1024px) {
    padding: 4rem 5.6rem;
  }
`;

export const StudentInfo = styled.div`
  display: flex;
  align-items: center;

  width: 100%;

  @media (min-width: 425px) {
    margin-right: 1.6rem;
  }

  > img {
    height: 6.4rem;

    width: 100%;
    max-width: 6.4rem;

    border-radius: 4px;

    @media (min-width: 768px) {
      height: 13.5rem;
      max-width: 13.5rem;
    }
  }

  .info {
    margin-left: 1.6rem;

    overflow: hidden;

    > h1,
    > p {
      font-weight: bold;
      color: #fff;

      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    > h1 {
      font-size: 2rem;
      line-height: 4.6rem;
    }

    > p {
      font-size: 1.2rem;
      line-height: 2.2rem;

      margin-top: 0.5rem;

      > span {
        font-weight: normal;
      }
    }

    @media (min-width: 768px) {
      > h1 {
        font-size: 3.8rem;
      }

      > p {
        font-size: 1.8rem;
      }
    }
  }
`;

export const StudentActions = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-around;

  margin: 0.8rem 0;

  > a,
  button {
    display: flex;
    align-items: center;
    justify-content: center;

    width: 100%;
    color: #fff;

    padding: 0.4rem;

    border-radius: 0.2rem;

    transition: ${({ theme }) => theme.transition.default};

    :hover {
      transform: scale(1.05);
    }

    :active {
      transform: scale(0.99);
    }

    :first-child {
      background: transparent linear-gradient(155deg, #ffdf22 0%, #ffd503 100%);
    }

    :last-child {
      background: transparent linear-gradient(155deg, #b50808 0%, #d90606 100%);
      margin-top: 0.8rem;
    }
  }

  @media (min-width: 425px) {
    > a,
    button {
      border-radius: 50%;
    }
  }

  @media (min-width: 768px) {
    flex-direction: row;
    align-items: baseline;

    margin: 0;

    > a,
    button {
      min-width: 4.5rem;
      min-height: 4.5rem;
    }

    > button {
      margin-top: 0rem;
      margin-left: 1.6rem;
    }
  }
`;

export const StudentContent = styled.div`
  width: 100%;

  overflow: hidden;
  padding: 6.3rem 5.8rem;

  @media (max-width: 425px) {
    padding: 2rem;
  }

  h1 {
    color: #fff;
  }
`;

export const ContainerLoading = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
`;

export const DeleteModalContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  h1 {
    margin-bottom: 3rem;
    text-transform: uppercase;
  }

  p {
    width: 80%;
    font-size: 1.8rem;
    text-align: center;
    margin-bottom: 6rem;
  }

  div {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-evenly;

    button {
      width: 10rem;
      height: 4rem;
      background: transparent linear-gradient(96deg, #000000 0%, #232323 100%)
        0% 0% no-repeat padding-box;
      border-radius: 50px;
      opacity: 1;

      color: #fff;
      font-weight: bold;

      transition: 0.2s;

      &:hover {
        filter: brightness(0.9);
      }
    }
  }
`;
